import { Koi } from '@ksyos/koi';
import { BatchType } from '@common/enums';

export type BatchRunValidated = {
    batchType: BatchType;
    runNumber: number;
};

export const batchRunSchema = Koi.object({
    batchType: Koi.koi().enum(BatchType).required(),
    runNumber: Koi.number().required(),
});
